module.exports = __webpack_public_path__ + "img/logo2.af250b71.png";